<div class="m-6">
  <h1 data-cy="test-agent-page-title">Test Agent Access</h1>
  <h2 data-cy="load-test-patient-form-title">Load Agent View</h2>
  <p-card styleClass="mb-5">
    <app-message *ngIf="showError" severity="error" data-cy="load-agent-view-form-error">
      {{ (createTestAgentOtpState$ | async)?.error?.uiMessage }}
    </app-message>
    <form [formGroup]="agentForm" (ngSubmit)="onSubmitAgentForm()" data-cy="load-agent-view-form">
      <app-form-field
        [limitWidth]="true"
        [control]="asFormControl(agentForm.get('patientId'))"
        name="patientId"
        label="Test Patient ID"
        [boldLabel]="true"
        type="input"
        inputType="number"
        inputMode="numeric"
      ></app-form-field>
      <app-form-field
        [control]="asFormControl(agentForm.get('agentToken'))"
        name="agentToken"
        label="Agent Access Token"
        labelHint="(Sign into ipims then grab the value of the Authorization request header and place here)"
        [boldLabel]="true"
        type="textarea"
      ></app-form-field>
      <div class="flex align-items-center">
        <button
          pButton
          class="button p-button-lg p-button-rounded"
          type="submit"
          [disabled]="(createTestAgentOtpState$ | async)?.isLoading"
          data-cy="load-agent-view-form-submit-button"
        >
          Go
        </button>
      </div>
    </form>
  </p-card>
</div>
